module.exports = __webpack_public_path__ + "img/roadmap-impostor-2.45801cf6.png";